import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { api } from '../api.js';

export default function Settings() {
  const { t } = useTranslation();
  const [form, setForm] = useState({ approvalThresholdCAD: 500, approvalThresholdUSD: 400, fiscalYearStartMonth: 10 });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get('/api/settings').then((res) => {
      const s = res.data.settings;
      setForm({
        approvalThresholdCAD: Number(s.approvalThresholdCAD),
        approvalThresholdUSD: Number(s.approvalThresholdUSD),
        fiscalYearStartMonth: s.fiscalYearStartMonth,
      });
    });
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.put('/api/settings', {
        approvalThresholdCAD: Number(form.approvalThresholdCAD),
        approvalThresholdUSD: Number(form.approvalThresholdUSD),
        fiscalYearStartMonth: Number(form.fiscalYearStartMonth),
      });
      toast.success(t('settings.saved'));
    } catch (err) { toast.error(err.message); }
    finally { setBusy(false); }
  };

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h1 className="text-lg font-semibold mb-4">{t('settings.title')}</h1>
      <form onSubmit={submit} className="card p-4 space-y-4">
        <div>
          <label className="label">{t('settings.thresholdCAD')}</label>
          <input type="number" step="0.01" min={0} className="input" value={form.approvalThresholdCAD} onChange={(e) => setForm({ ...form, approvalThresholdCAD: e.target.value })} />
          <p className="text-[11px] text-zinc-600 mt-1">{t('settings.thresholdHint')}</p>
        </div>
        <div>
          <label className="label">{t('settings.thresholdUSD')}</label>
          <input type="number" step="0.01" min={0} className="input" value={form.approvalThresholdUSD} onChange={(e) => setForm({ ...form, approvalThresholdUSD: e.target.value })} />
        </div>
        <div>
          <label className="label">{t('settings.fiscalYearStart')}</label>
          <select value={form.fiscalYearStartMonth} onChange={(e) => setForm({ ...form, fiscalYearStartMonth: e.target.value })} className="input">
            {[1,2,3,4,5,6,7,8,9,10,11,12].map((m) => <option key={m} value={m}>{m}</option>)}
          </select>
          <p className="text-[11px] text-zinc-600 mt-1">{t('settings.fiscalHint')}</p>
        </div>
        <div className="flex justify-end">
          <button type="submit" disabled={busy} className="btn-primary">{busy ? t('common.saving') : t('common.save')}</button>
        </div>
      </form>
    </div>
  );
}
